export const NO_REACTION = 'NoReaction';